import wretch from 'wretch'

export const updatePasswordMutation = {
  mutationFn: (data: { password: string; token: string }) => {
    return wretch(`${import.meta.env.VITE_API_BASE_URL}/business/v1/user/password/update`)
      .headers({ Authorization: data.token })
      .post(data)
      .json()
  },
}
